module.exports = __webpack_public_path__ + "static/media/canoe.ea8faca2.gif";